import { render, staticRenderFns } from "./OpenDisputeDialog.vue?vue&type=template&id=3dc423b7&"
import script from "./OpenDisputeDialog.vue?vue&type=script&lang=js&"
export * from "./OpenDisputeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports